import { jsxs as k, jsx as B } from "react/jsx-runtime";
import { useRouter as w } from "next/router";
import { useI18n as $ } from "next-localization";
import { OperatingStatusCodes as G } from "../types/search/index.js";
import { c as I } from "./create-location-link.CWUHCgFz.js";
import { B as V } from "./button-link.Cv6YTl23.js";
import { useState as D, useEffect as v } from "react";
var d = /* @__PURE__ */ ((i) => (i.SpecialtyButton = "SpecialtyButton", i.WebsiteButton = "WebsiteButton", i.GetDirectionsButton = "GetDirectionsButton", i.WebCheckInButton = "WebCheckInButton", i.PhoneButton = "PhoneButton", i.VirtualVisitButton = "VirtualVisitButton", i.ViewOnMapButton = "ViewOnMapButton", i))(d || {});
const {
  SpecialtyButton: S,
  WebsiteButton: z,
  GetDirectionsButton: x,
  WebCheckInButton: R,
  PhoneButton: U,
  VirtualVisitButton: y,
  ViewOnMapButton: T
} = d, M = [
  S,
  z,
  x,
  R,
  U,
  y,
  T
], N = {
  IOS: "https://maps.apple.com/?q=",
  Android: "geo:0,0?q=",
  default: "https://www.google.com/maps/dir/?api=1&destination="
};
var A = /* @__PURE__ */ ((i) => (i.IOS = "IOS", i.Android = "Android", i.MacOS = "MacOS", i.Windows = "Windows", i.Other = "Other", i))(A || {});
const P = () => {
  const [i, a] = D(
    "Other"
    /* Other */
  );
  return v(() => {
    (() => {
      const t = navigator.userAgent.toLowerCase();
      /iphone|ipad|ipod/g.test(t) ? a(
        "IOS"
        /* IOS */
      ) : /android/g.test(t) ? a(
        "Android"
        /* Android */
      ) : /windows/g.test(t) ? a(
        "Windows"
        /* Windows */
      ) : /mac/g.test(t) ? a(
        "MacOS"
        /* MacOS */
      ) : a(
        "Other"
        /* Other */
      );
    })();
  }), i;
}, F = ({
  result: i,
  facilityName: a,
  className: e,
  kind: t = "secondary",
  size: h = "small",
  icon: f
}) => {
  const { t: o } = $(), m = P();
  if (!(i != null && i.latitude) || !(i != null && i.longitude))
    return null;
  const c = m in N ? m : "default", C = {
    value: {
      href: `${N[c]}${i == null ? void 0 : i.latitude},${i == null ? void 0 : i.longitude}`,
      target: "_blank",
      text: o("Common.GetDirections")
    }
  };
  return /* @__PURE__ */ k(
    V,
    {
      kind: t,
      size: h,
      "aria-label": `${o("Common.GetDirections")} ${a}`,
      className: e,
      icon: f,
      field: C,
      children: [
        o("Common.GetDirections"),
        " ",
        /* @__PURE__ */ B("span", { className: "sr-only", children: a })
      ]
    },
    i == null ? void 0 : i.itemId
  );
}, _ = ({
  result: i,
  facilityName: a,
  className: e,
  kind: t = "secondary",
  size: h = "small",
  icon: f
}) => {
  var c;
  const { t: o } = $(), m = {
    value: {
      href: `tel:${(c = i == null ? void 0 : i.marketedPrimaryPhoneNumber) == null ? void 0 : c.replace(/ /g, "")}`,
      text: i == null ? void 0 : i.marketedPrimaryPhoneNumber
    }
  };
  return i != null && i.marketedPrimaryPhoneNumber ? /* @__PURE__ */ k(
    V,
    {
      kind: t,
      size: h,
      className: e,
      "aria-label": `${o("Locations.Card.PhoneNumber")} ${a}`,
      editable: !1,
      field: m,
      icon: f,
      children: [
        i == null ? void 0 : i.marketedPrimaryPhoneNumber,
        " ",
        /* @__PURE__ */ B("span", { className: "sr-only", children: a })
      ]
    }
  ) : null;
}, j = ({
  result: i,
  facilityName: a,
  className: e,
  kind: t,
  size: h,
  icon: f
}) => {
  const { t: o } = $();
  return /* @__PURE__ */ k(
    V,
    {
      kind: t,
      size: h,
      editable: !1,
      className: e,
      icon: f,
      "aria-label": `${o("Locations.Card.VirtualVisit")} ${a}`,
      field: I({
        text: o("Locations.Card.VirtualVisit"),
        url: i == null ? void 0 : i.virtualVisitRegistrationUrl
      }),
      children: [
        o("Locations.Card.VirtualVisit"),
        " ",
        /* @__PURE__ */ B("span", { className: "sr-only", children: a })
      ]
    }
  );
}, q = ({
  result: i,
  facilityName: a,
  className: e,
  kind: t,
  size: h,
  icon: f
}) => {
  const { t: o } = $();
  return /* @__PURE__ */ k(
    V,
    {
      kind: t,
      size: h,
      editable: !1,
      className: e,
      field: I({
        text: o("Locations.Card.WebCheckIn"),
        url: i == null ? void 0 : i.onsiteVisitRegistrationUrl
      }),
      icon: f,
      children: [
        o("Locations.Card.WebCheckIn"),
        " ",
        /* @__PURE__ */ B("span", { className: "sr-only", children: a })
      ]
    },
    `on-site-visit-${i == null ? void 0 : i.itemId}`
  );
}, u = ({
  result: i,
  cardButtonsClassName: a,
  selectedSpecialty: e,
  viewOnMapUrl: t,
  onViewOnMapClick: h,
  buttonOrder: f,
  buttonProps: o
}) => {
  const { t: m } = $(), c = (i == null ? void 0 : i.marketedFacilityName) ?? (i == null ? void 0 : i.facilityName) ?? (i == null ? void 0 : i.locationName) ?? "", b = H({
    locationSpecialties: i == null ? void 0 : i.locationSpecialties,
    selectedSpecialty: e
  }), C = w(), L = (g) => {
    if (g.preventDefault(), h) return h(g);
    C.push(`/${t}`);
  }, W = ((i == null ? void 0 : i.operatingStatusCodeOverride) ?? (i == null ? void 0 : i.operatingStatusCode)) !== G.Planned;
  return (f ?? M).map((g) => {
    let n;
    switch (g) {
      case d.SpecialtyButton:
        return n = o && o[d.SpecialtyButton], /* @__PURE__ */ k(
          V,
          {
            kind: n == null ? void 0 : n.kind,
            size: n == null ? void 0 : n.size,
            className: (n == null ? void 0 : n.className) ?? a,
            "aria-label": `${m("Locations.Card.GoTo")} ${e} ${c}`,
            icon: n == null ? void 0 : n.icon,
            editable: !1,
            field: I({
              text: m("Locations.Card.GoToSpecialty"),
              url: b == null ? void 0 : b.url
            }),
            children: [
              m("Locations.Card.GoToSpecialty"),
              " ",
              /* @__PURE__ */ B("span", { className: "sr-only", children: c })
            ]
          },
          `specialty-${i == null ? void 0 : i.itemId}`
        );
      case (((i == null ? void 0 : i.locationUrl) || (i == null ? void 0 : i.marketedWebsite)) && d.WebsiteButton): {
        n = o && o[d.WebsiteButton];
        const O = I({
          text: m("Locations.Card.GoToWebsite"),
          url: (i == null ? void 0 : i.locationUrl) || (i == null ? void 0 : i.marketedWebsite) || ""
        });
        return /* @__PURE__ */ k(
          V,
          {
            kind: (n == null ? void 0 : n.kind) ?? "secondary",
            size: (n == null ? void 0 : n.size) ?? "small",
            className: (n == null ? void 0 : n.className) ?? a,
            "aria-label": `${m("Locations.Card.GoToWebsite")} ${c}`,
            icon: n == null ? void 0 : n.icon,
            editable: !1,
            field: O,
            children: [
              m("Locations.Card.GoToWebsite"),
              " ",
              /* @__PURE__ */ B("span", { className: "sr-only", children: c })
            ]
          },
          `go-to-website-${i == null ? void 0 : i.itemId}`
        );
      }
      case (W && d.GetDirectionsButton):
        return n = o && o[d.GetDirectionsButton], /* @__PURE__ */ B(
          F,
          {
            className: (n == null ? void 0 : n.className) ?? a,
            result: i,
            facilityName: c,
            kind: n == null ? void 0 : n.kind,
            size: n == null ? void 0 : n.size,
            icon: n == null ? void 0 : n.icon
          },
          `directions-${i == null ? void 0 : i.itemId}`
        );
      case ((i == null ? void 0 : i.onsiteVisitRegistrationUrl) && d.WebCheckInButton):
        return n = o && o[d.WebCheckInButton], /* @__PURE__ */ B(
          q,
          {
            className: (n == null ? void 0 : n.className) ?? a,
            result: i,
            facilityName: c,
            kind: n == null ? void 0 : n.kind,
            size: n == null ? void 0 : n.size,
            icon: n == null ? void 0 : n.icon
          },
          `on-site-visit-${i == null ? void 0 : i.itemId}`
        );
      case d.PhoneButton:
        return n = o && o[d.PhoneButton], /* @__PURE__ */ B(
          _,
          {
            kind: n == null ? void 0 : n.kind,
            size: n == null ? void 0 : n.size,
            className: (n == null ? void 0 : n.className) ?? a,
            "aria-label": `${m("Locations.Card.PhoneNumber")} ${c}`,
            result: i,
            icon: n == null ? void 0 : n.icon,
            facilityName: c
          },
          `phone-number-${i == null ? void 0 : i.itemId}`
        );
      case ((i == null ? void 0 : i.virtualVisitRegistrationUrl) && d.VirtualVisitButton):
        return n = o && o[d.VirtualVisitButton], /* @__PURE__ */ B(
          j,
          {
            className: (n == null ? void 0 : n.className) ?? a,
            result: i,
            facilityName: c,
            kind: n == null ? void 0 : n.kind,
            size: n == null ? void 0 : n.size,
            icon: n == null ? void 0 : n.icon
          },
          `virtual-visit-${i == null ? void 0 : i.itemId}`
        );
      case d.ViewOnMapButton:
        return n = o && o[d.ViewOnMapButton], /* @__PURE__ */ k(
          V,
          {
            kind: (n == null ? void 0 : n.kind) ?? "secondary",
            size: (n == null ? void 0 : n.size) ?? "small",
            className: (n == null ? void 0 : n.className) ?? a,
            "aria-label": `${m("Locations.Card.ViewOnMap")} ${c}`,
            icon: n == null ? void 0 : n.icon,
            editable: !1,
            field: {
              value: {
                href: "#",
                text: m("Locations.Card.ViewOnMap")
              }
            },
            onClick: (O) => {
              L == null || L(O);
            },
            children: [
              m("Locations.Card.ViewOnMap"),
              " ",
              /* @__PURE__ */ B("span", { className: "sr-only", children: c })
            ]
          },
          `view-on-map-${i == null ? void 0 : i.itemId}`
        );
      default:
        return null;
    }
  });
};
function H({
  locationSpecialties: i,
  selectedSpecialty: a
}) {
  return a && i ? i.find((e) => (e == null ? void 0 : e.name) === a) : null;
}
function J({
  locationSpecialties: i,
  selectedSpecialty: a
}) {
  let e, t = (a == null ? void 0 : a.toLowerCase()) ?? "";
  for (; e === void 0 && t.includes("/"); )
    e = i == null ? void 0 : i.find((h) => {
      var f;
      return (f = h == null ? void 0 : h.url) == null ? void 0 : f.includes(t);
    }), t = t.slice(0, t.lastIndexOf("/"));
  return e;
}
const p = ({
  locationSpecialties: i,
  selectedSpecialty: a
}) => a && i ? J({ locationSpecialties: i, selectedSpecialty: a }) : null;
export {
  d as C,
  M as D,
  F as G,
  _ as P,
  j as V,
  q as W,
  N as a,
  u as b,
  H as c,
  A as d,
  p as g,
  P as u
};
